module.exports = __webpack_public_path__ + "img/CV.af84065b.svg";